import { install as barExtension } from './series/bar';
import { install as lineExtension } from './series/line/index';
import { install as treemapExtension } from './series/treemap';
import { install as sankeyExtension } from './series/sankey';
import { install as dvScatterExtension } from './series/dvScatter';
import { install as dvMarkerExtension } from './series/dvMarker';
import { install as beeswarmExtension } from './series/beeswarm';
import { install as dvRankLineExtension } from './series/dvRankLine';
import { install as dvTwoWayTreeExtension } from './series/dvTwoWayTree';
import { install as dvWordCloudExtension } from './series/dvWordCloud';
import { install as petalActionExtension } from './series/petal/action';
import { install as dvWaterfallExtension } from './series/dvWaterfall';
import { install as dvVennExtension } from './series/dvVenn';
import { install as dvRadarExtension } from './series/dvRadar';
import { install as dvRelationshipDiagramExtension } from './series/dvRelationshipDiagram';
import { install as axisExtension } from './component/axis';
import { install as tooltipExtension } from './component/tooltip';
import { install as axisPointerExtension } from './component/axisPointer/axisPointer';
import { install as shadowAxisPointerExtension } from './component/axisPointer/shadowAxisPointer';
import { install as dataZoomExtension } from './component/dataZoom/index';
import { install as roamExtension } from './component/roam';
import { install as shapePinExtension } from './graphic/Pin';
import { install as dvWaterMarkExtension } from './component/dvWaterMark';
import { install as gridExtension } from './component/grid';
import { install as shapeCurveLineExtension } from './graphic/CurveLine';

export { install as guideExampleExtension } from './guide';

// * component
export const componentExtensions = [
  axisExtension,
  tooltipExtension,
  axisPointerExtension,
  shadowAxisPointerExtension,
  dataZoomExtension,
  roamExtension,
  dvWaterMarkExtension,
  gridExtension
];

// * series
export const chartExtensions = [
  barExtension,
  lineExtension,
  treemapExtension,
  sankeyExtension,
  dvScatterExtension,
  dvMarkerExtension,
  beeswarmExtension,
  dvTwoWayTreeExtension,
  dvRankLineExtension,
  dvWordCloudExtension,
  petalActionExtension,
  dvWaterfallExtension,
  dvVennExtension,
  dvRadarExtension,
  dvRelationshipDiagramExtension
];

export const graphicExtensions = [shapePinExtension, shapeCurveLineExtension];
